import React from 'react'
import BaseInputs from './baseInputs'
import { Label } from 'reactstrap'
import DateValidInputs from './dateValidInputs'
import Resx from '@/components/Resx'
import { EnumDropDownList } from '@/components/enumDropDownList'
import { personStatusTypes } from '@/enums/personStatusTypes'
import { Validator } from '@/components/validation'

export default class HasPersonStatusTypeItemForm extends React.Component {
  constructor (props, context) {
    super(props, context)

    this.state = {
      id: props.item ? props.item.id : undefined,
      name: props.item ? props.item.name : '',
      latinName: props.item ? props.item.latinName : '',
      code: props.item ? props.item.code : '',
      legacyCode: props.item ? props.item.legacyCode : '',
      validFrom: props.item ? props.item.validFrom : null,
      validTo: props.item ? props.item.validTo : null,
      statusType: props.item ? props.item.statusType : null
    }
  }

  onInputChange (values) {
    this.setState({ ...values },
      () => this.onChange())
  }

  onChange () {
    this.props.onChange({
      id: this.state.id,
      name: this.state.name,
      latinName: this.state.latinName,
      code: this.state.code,
      legacyCode: this.state.legacyCode,
      validFrom: this.state.validFrom,
      validTo: this.state.validTo,
      statusType: this.state.statusType
    })
  }

  render () {
    const { isReadOnly } = this.props

    return (
      <div>
        <BaseInputs name={this.state.name} latinName={this.state.latinName} code={this.state.code} legacyCode={this.state.legacyCode} isReadOnly={isReadOnly}
          onChange={(values) => this.onInputChange(values)} />
        <Label><Resx name='Common.StatusType' /></Label>
        <Validator name='statusType' value={this.state.statusType} required>
          <EnumDropDownList enumDefinition={personStatusTypes} allowClear onChange={value => this.onInputChange({ statusType: value.item.value })} value={this.state.statusType} />
        </Validator>
        <DateValidInputs validFrom={this.state.validFrom} validTo={this.state.validTo} isReadOnly={isReadOnly}
          onChange={(values) => this.onInputChange(values)} />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/codeLists/hasPersonStatusTypeItemForm.js